const items = {
  "buttons.submit": "submit",
  "buttons.create": "create",
  "buttons.edit": "edit",
  "buttons.translate": "translate",
  "buttons.read": "read",
  "buttons.wbw": "wbw",
  "buttons.delete": "delete",
  "buttons.remove": "remove",
  "buttons.delete.all": "delete all",
  "buttons.selected": "selected",
  "buttons.select": "select",
  "buttons.unselect": "unselect",
  "buttons.option": "operation",
  "buttons.save": "save",
  "buttons.save.publish": "save & publish",
  "buttons.save.my.dict": "save & my dict",
  "buttons.cancel": "cancel",
  "buttons.setting": "setting",
  "buttons.sign-in": "sign in",
  "buttons.sign-out": "sign out",
  "buttons.welcome": "welcome",
  "buttons.click.upload": "click and upload",
  "buttons.group.exit": "exit",
  "buttons.group.add.member": "add member",
  "buttons.lesson.add.lesson": "加入",
  "buttons.ok": "ok",
  "buttons.close": "close",
  "buttons.copy": "copy",
  "buttons.paste": "paste",
  "buttons.copy.to": "copy to",
  "buttons.copy.text": "copy text",
  "buttons.copy.pali.text": "copy pali text",
  "buttons.basic.information": "basic information",
  "buttons.share": "share",
  "buttons.yes": "yes",
  "buttons.no": "no",
  "buttons.open.in.library": "open in library",
  "buttons.preview": "preview",
  "buttons.view": "view",
  "buttons.empty": "empty",
  "buttons.basic": "basic",
  "buttons.bookmark": "bookmark",
  "buttons.note": "note",
  "buttons.advance": "advance",
  "buttons.attachments": "attachments",
  "buttons.sim": "sim",
  "buttons.add": "add",
  "buttons.spell": "spell",
  "buttons.more": "more",
  "buttons.import": "import",
  "buttons.export": "export",
  "buttons.add.tag": "add tag",
  "buttons.remove.selected": "remove selected",
  "buttons.multiple.select": "multiple select",
  "buttons.download": "download",
  "buttons.download.link": "download link",
  "buttons.lookup": "lookup",
  "buttons.invite": "invite",
  "buttons.relate.to": "relate to",
  "buttons.copy.link": "copy link",
  "buttons.copy.id": "copy id",
  "buttons.reply": "reply",
  "buttons.open": "open",
  "buttons.compact": "compact",
  "buttons.magic-dict": "magic-dict",
  "buttons.theme.ant": "theme ant",
  "buttons.theme.dark": "theme dark",
  "buttons.channel.all": "all",
  "buttons.channel.my": "my",
  "buttons.channel.collaborator": "collaborate",
  "buttons.channel.public": "public",
  "buttons.refresh": "refresh",
  "buttons.timeline": "timeline",
  "buttons.discussion": "discussion",
  "buttons.suggestion": "suggestion",
  "buttons.accept": "accept",
  "buttons.refuse": "refuse",
  "buttons.use.as.guest": "use as guest",
  "buttons.got.it": "I got it",
  "buttons.statistic": "statistic",
  "buttons.relate": "relate",
  "buttons.convert": "convert",
  "buttons.copy.tpl": "copy template",
  "buttons.open.in.new.tab": "Open {item} in New Tab",
  "buttons.add_to_anthology": "Add to Anthology",
  "buttons.open.in.studio": "Open in Studio",
  "buttons.admin": "admin",
  "buttons.open.in.tab": "Open in New Tab",
  "buttons.reset.wbw": "reset wbw",
  "buttons.reset.password": "reset password",
  "buttons.forgot.password": "forgot password",
  "buttons.select.channel": "Select Channel",
  "buttons.set.display.mode": "Display Mode",
  "buttons.manage": "Manage",
  "buttons.delete.wbw.sentence": "Delete Wbw",
  "buttons.ai.translate": "AI Translate",
  "buttons.task.status.change.to.published": "publish",
  "buttons.task.status.change.to.running": "领取",
  "buttons.task.status.change.to.done": "done",
  "buttons.task.status.change.to.restarted": "restart",
  "buttons.task.status.change.to.requested_restart": "request restart",
  "buttons.task.status.change.to.quit": "quit",
  "buttons.access-token.get": "access token",
  "buttons.task.add.pre-task": "pre task",
  "buttons.task.add.next-task": "next task",
  "buttons.remove.milestone": "remove milestone",
  "buttons.set.milestone": "set as milestone",
  "buttons.next": "Next",
  "buttons.previous": "Previous",
  "buttons.clone": "Clone",
  "buttons.general": "General",
  "buttons.ai-models": "AI Models",
  "buttons.new": "New",
};

export default items;
